<!-- Main Container -->
<div class="container-fluid">
  <div class="row">
    <!-- Video Section -->
    <div class="col-9 p-0" [ngClass]="showEmotions ? 'col-9' : 'col-12'">
      <div
        class="meeting_body"
        [ngClass]="apiservice.isScreenShare ? 'screen_sharing' : ''"
      >
        <!-- Header -->
        <app-header></app-header>
        <!-- END Header -->
        <div class="position-relative">
          <!-- Body -->
          <div class="video-body">
            <!-- Video Details -->
            <div class="video_details_wrapper">
              <div
                class="agent_name"
                *ngIf="apiservice.validation?.call_type === 'video_call'"
              >
                <h3>
                  {{
                    apiservice.remote_video
                      ? apiservice.remote_view_data.uname
                      : apiservice.session_details.user_name
                  }}
                </h3>
                <h5>
                  {{ gethost() }}
                </h5>
              </div>

              <div
                class="audio_mic text-center"
                *ngIf="
                  apiservice.validation?.call_type === 'video_call' &&
                  !apiservice.isScreenShare
                "
              >
                <!-- Audio Visualizer -->
                <div
                  class="audio_visualizer"
                  *ngIf="
                    apiservice.remote_video
                      ? apiservice.remote_view_data.audioStatus
                      : apiservice.session_details.audio_status
                  "
                >
                  <img
                    src="assets/images/audio_visualizer.svg"
                    alt="Audio visualizer"
                  />
                </div>
                <!-- END Audio Visualizer -->
              </div>

              <!-- Audio Mic Off -->
              <div
                class="mic_off"
                *ngIf="
                  apiservice.remote_video
                    ? !apiservice.remote_view_data.audioStatus
                    : !apiservice.session_details.audio_status
                "
              >
                <em class="bi-mic-mute me-2"></em>
                <span>Microphone Off</span>
              </div>
              <!-- END Audio Mic Off -->
            </div>
            <!-- END Video Details -->

            <!-- Screen-share Details -->
            <div
              class="screen_share_details_wrapper"
              *ngIf="apiservice.isScreenShare"
            >
              <div
                class="agent_name"
                *ngIf="apiservice.validation?.call_type === 'video_call'"
              >
                <h4>
                  {{
                    apiservice.remote_video
                      ? apiservice.session_details.user_name
                      : apiservice.remote_view_data.uname
                  }}
                  <span class="small">{{
                    apiservice.localVideoStream
                      ? "(You, Presenting)"
                      : "Presenting"
                  }}</span>
                </h4>
              </div>

              <div
                class="stop_sharing text-center"
                *ngIf="
                  apiservice.validation?.call_type === 'video_call' &&
                  apiservice.isScreenShare
                "
              >
                <!-- Stop sharing button -->
                <div class="stop_sharing_btn">
                  <button
                    class="btn btn-xs btn-primary"
                    type="button"
                    (click)="stopCapture()"
                  >
                    Stop Sharing
                  </button>
                </div>
                <!-- END Stop sharing button -->
              </div>
            </div>
            <!-- END Screen-share Details -->

            <ng-container
              [ngTemplateOutlet]="displayLocalTemplate"
            ></ng-container>
          </div>
          <!-- End Body -->

          <!-- Footer -->
          <div class="footer p-0">
            <!-- Remote Video -->
            <div class="remote_minimized_video" *ngIf="apiservice.remote_video">
              <div
                class="d-flex align-items-center justify-content-between gap-2"
              >
                <div class="video_wrapper">
                  <h3 class="mb-2">
                    <span *ngIf="!apiservice.session_details.audio_status">
                      <em class="bi-mic-mute-fill text-light"></em>
                    </span>
                    {{ apiservice.session_details.user_name }}
                  </h3>
                  <div class="ftr_video">
                    <div class="ftr_video_container">
                      <div class="circular-video">
                        <ng-container
                          [ngTemplateOutlet]="displayVideoTemplate"
                        ></ng-container>
                        <ng-template #localvideo>
                          <app-localvideo></app-localvideo>
                        </ng-template>
                        <ng-template #remotevideo>
                          <app-remotevideo></app-remotevideo>
                        </ng-template>
                      </div>
                      <div
                        *ngIf="!apiservice.session_details.video_status"
                        class="video_overlap"
                      >
                        {{ getShortName(apiservice.session_details.user_name) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Remote Video -->

            <!-- Call Options -->
            <div class="bottom-layout p-0">
              <div class="row m-0">
                <div class="col-5">
                  <div class="stop_sharing_popup">
                    <!-- <button class="btn btn-sm btn-default">
                <span class="stop_icon"><em class="bi bi-x"></em></span>Stop
                sharing
              </button> -->
                  </div>

                  <div class="controls call-options float-end">
                    <!-- Whiteboard Icon -->
                    <!-- <div class="ftr_img_icon active">
                <img
                  class="img-fluid"
                  src="assets/images/whiteboard_off.svg"
                  alt="Whiteboard off"
                />
              </div> -->
                    <!-- END Whiteboard Icon -->

                    <!-- Screen Share Icon -->
                    <div
                      class="ftr_img_icon share_opt"
                      [ngClass]="
                        (apiservice.showScreenShare | async) &&
                        apiservice.isScreenShare
                          ? 'active'
                          : ''
                      "
                      *ngIf="apiservice.showScreenShare | async"
                      matTooltip="{{
                        !apiservice.isScreenShare
                          ? 'Share screen'
                          : 'You are Presenting'
                      }}"
                    >
                      <img
                        (click)="startScreenShare()"
                        class="img-fluid"
                        src="assets/images/share_on.svg"
                        alt="Share screen"
                      />
                    </div>
                    <!-- END Screen Share Icon -->

                    <!-- Audio Option -->
                    <div
                      class="footer_audio"
                      [ngClass]="
                        apiservice.session_details.audio_status ? 'active' : ''
                      "
                      (click)="
                        apiservice.session_details.audio_status
                          ? this.MuteAudio()
                          : this.EnableAudio()
                      "
                      matTooltip="Mute/Unmute audio"
                    >
                      <em
                        class="bi"
                        [ngClass]="
                          apiservice.session_details.audio_status
                            ? 'bi-mic'
                            : 'bi-mic-mute-fill'
                        "
                      ></em>
                    </div>
                    <!-- END Audio Option -->

                    <!-- Video Option -->
                    <div
                      class="footer_video"
                      [ngClass]="
                        apiservice.session_details.video_status ? 'active' : ''
                      "
                      (click)="
                        apiservice.session_details.video_status
                          ? this.PauseVideo()
                          : this.EnableVideo()
                      "
                      *ngIf="
                        apiservice.validation?.call_type === 'video_call' &&
                        !apiservice.isScreenShare
                      "
                      matTooltip="Video on/off"
                    >
                      <em
                        class="bi"
                        [ngClass]="
                          apiservice.session_details.video_status
                            ? 'bi-camera-video'
                            : 'bi-camera-video-off-fill'
                        "
                      ></em>
                    </div>
                    <!-- END Video Option -->

                    <!-- Emotional Analysis -->
                    <!-- <div
                class="footer_video"
                [ngClass]="apiservice.session_details.video_status ? 'active' : ''"
                *ngIf="apiservice.validation?.call_type === 'video_call' && apiservice.remote_video"
                matTooltip="Analyze customer emotions"
                (click)="showEmotions = !showEmotions"
              >
                <em
                  class="bi"
                  [ngClass]="
                    apiservice.session_details.video_status
                      ? 'bi-emoji-smile'
                      : 'bi-emoji-smile-fill'
                  "
                ></em>
              </div> -->
                    <!-- END Emotional Analysis -->
                  </div>
                </div>

                <div class="col-2">
                  <!-- Footer Call End Option -->
                  <div class="ftr_call_end">
                    <div class="hungup" (click)="disconnectCall()">
                      <div class="inner-bg">
                        <em class="bi bi-telephone-fill hangup_icon"></em>
                      </div>
                    </div>
                  </div>
                  <!-- END Footer Call End Option -->
                </div>

                <!-- Call Duration -->
                <div class="col-5">
                  <div class="controls timer">
                    <div class="stop-watch text-white">
                      {{ apiservice.timer$ | async }}
                    </div>
                  </div>
                </div>
                <!-- END Call Duration -->
              </div>
            </div>
            <!-- Call Options -->
          </div>
          <!-- END Footer -->
          @if (!this.ss.isConnected) {
          <!-- Reconnecting Overlay -->
          <div class="reconnecting-overlay">
            <div class="spinner-icon">🔄</div>
            @if (ss.reconnectAttempts&& ss.isConnecting) {
            <h2>Reconnecting...</h2>
            <p>Please wait while we try to restore the connection.</p>
            } @else if (ss.isConnecting) {
            <h2>Connecting...</h2>
            <p>Please wait while we establish the connection.</p>
            }@else {
            <h2>Connection lost...</h2>
            <p>Hang tight, we are trying to reconnect.</p>
            <p class="sub-text">Retrying in 5s</p>
            }
          </div>
          <!-- END Reconnecting Overlay -->
          }
        </div>
      </div>
    </div>
    <!-- Video Section -->

    <!-- Emotional Analysis, Video Group -->
    <div class="col-3 p-0" *ngIf="showEmotions">
      <div class="card vh-100 p-0 emotional_analysis">
        <div class="card-header p-3">
          <h3>Emotional Analysis</h3>
          <div
            class="close_emotions_card"
            (click)="showEmotions = !showEmotions"
          >
            <em class="bi-x-circle fs-5"></em>
          </div>
        </div>

        <div class="card-body">
          <!-- Emotional Details -->
          <div class="emotion_details my-2">
            <dl class="row row-cols-3">
              <dt class="col-3">Full Name</dt>
              <dt class="col-1">:</dt>
              <dd class="col-8 fw-bold text-left">Ravi raj</dd>

              <dt class="col-3">Gender</dt>
              <dt class="col-1">:</dt>
              <dd class="col-8 fw-bold text-left">Male</dd>

              <dt class="col-3">Age</dt>
              <dt class="col-1">:</dt>
              <dd class="col-8 fw-bold text-left">25yrs</dd>
            </dl>
          </div>
          <!-- End Emotional Details -->

          <!-- Emotions Card -->
          <div class="card card-bg card-border mb-3">
            <div class="emotions">
              <div
                class="emotion"
                *ngFor="let emotion of emotions; let i = index"
              >
                <span class="emotion_type">
                  <img class="emotion_icon" [src]="emotion.imgUrl" alt="icon" />
                  <h4 class="emotion_name">{{ emotion.name }}</h4>
                </span>
                <h3 class="emotion_value" [ngStyle]="{ color: i | color }">
                  {{ emotion.per }}%
                </h3>
              </div>
            </div>
          </div>
          <!-- END Emotions Card -->

          <!-- Emotion Analysis Chart -->
          <div class="chart_row">
            <div class="emotion_chart">
              <canvas
                class="chart"
                baseChart
                [datasets]="emotionAnalysisdataSets"
                [labels]="emotionAnalysislables"
                [legend]="emotionAnalysislegend"
                [options]="emotionAnalysisoptions"
                [type]="'line'"
              >
              </canvas>
            </div>
          </div>
          <!-- END Emotion Analysis Chart -->
        </div>

        <div class="card-footer p-2 text-center">
          <button class="btn btn-link text-primary">More Details</button>
        </div>
      </div>
    </div>
    <!-- END Emotional Analysis, Video Group -->
  </div>
</div>
<!-- END Main Container -->

<!-- Local Video -->
<ng-template #showLocalVideo>
  <app-videocall></app-videocall>
</ng-template>
<!-- END Local Video -->

<!-- Audio Template -->
<ng-template #showLocalAudio>
  <app-audiocall></app-audiocall>
</ng-template>
<!-- END Audio Template -->

<!-- Pause Video -->
<!-- <ng-container
  *ngIf="
    validation?.call_type === 'video_call' &&
    !apiservice.local_view_data.user.videoStatus
  "
>
  <div class="call-wrapper text-center">
    <div class="pause_video">
      <div class="my-2 pause_icon">
        <em class="bi bi-camera-video-off-fill btn-icon"></em>
      </div>
      <h3 class="my-2 text-white">Video Paused</h3>
    </div>
  </div>
</ng-container> -->
<!-- END Pause Video -->

<ng-template #mediaUpload let-c="close" let-d="dismiss">
  <div class="media_library">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h4 class="modal-title">Media Upload</h4>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="d('Cross click')"
        ></button>
      </div>
      <div class="modal-body text-center py-2"></div>
      <div class="modal-footer p-3">
        <button type="button" class="btn btn-light" (click)="d('Cross click')">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>
